import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition, MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { UrlContant } from 'src/app/constants/router.contant';
import { COMMON_REGEXP } from 'src/app/constants/validations';
import { AuthenticationService } from 'src/app/public-module/services/authentication.service';
import { SharedService } from 'src/app/public-module/services/shared.service';
import { ValidationsComponent } from 'src/app/shared-module/component/validations/validations.component';

@Component({
  selector: 'app-pandit-forgot-email',
  templateUrl: './pandit-forgot-email.component.html',
  styleUrls: ['./pandit-forgot-email.component.scss']
})
export class PanditForgotEmailComponent
extends ValidationsComponent
implements OnInit {

 // Form Variables
 forgotEmailForm: FormGroup;




 constructor(
   private _fb: FormBuilder,
   private _authenticationService: AuthenticationService,
   private _snackBar: MatSnackBar,
   private _router: Router,
   private _sharedService: SharedService
 ) {
   super();
 }

 ngOnInit(): void {
   this.createForgotForm();
 }

 createForgotForm() {
   this.forgotEmailForm = this._fb.group({
    email: ['', [Validators.pattern(COMMON_REGEXP.EMAIL_ADDRESS_REGEXP)]],
   });
 }

 onSubmitForgotEmailForm(form: FormGroup) {
  if(form.valid) {
    const params = form.value;
    const formData: any = new FormData();
    formData.append('email', params.email);
    this._authenticationService.panditForgotPassword(formData).subscribe(res => {
      this._sharedService.onShowMessageBar(res.message);
      this._router.navigate(['/' + UrlContant.PANDIT_LOGIN]);
    });
  }
 }

 get formControls() {
   return this.forgotEmailForm.controls;
 }
}
